import type { ReactNode } from 'react';
import React, { Children } from 'react';
import { getLabel } from 'Components/widgets/product-price-modal/ProductPriceModal.utils';
import { PopOver } from 'Components/frameworks/pop-over/PopOver';
import { ProductPriceInfo } from 'Components/widgets/product-price-info/ProductPriceInfo';
type Props = {
  children: ReactNode;
  className?: string;
  city: string;
  endDate: string;
  hasTransport?: boolean;
  isCruise?: boolean;
  isJoyview?: boolean;
  isTour?: boolean;
  onClick?: (e?: React.SyntheticEvent<any>) => void;
  onClickButton?: (e: React.SyntheticEvent<any>) => void;
  rate?: string;
  startDate: string;
  unit: string;
};
export const ProductPriceModal = ({
  children,
  className,
  city,
  endDate,
  hasTransport = false,
  isCruise = false,
  isJoyview = false,
  isTour = false,
  onClick,
  onClickButton,
  rate,
  startDate,
  unit,
}: Props) => {
  if (!Children.count(children)) {
    return null;
  }

  return (
    <PopOver
      ariaLabel={getLabel({
        isJoyview,
        isTour,
      })}
      className={className}
      content={
        <ProductPriceInfo
          city={city}
          endDate={endDate}
          hasTransport={hasTransport}
          isCruise={isCruise}
          isJoyview={isJoyview}
          isTour={isTour}
          onClick={onClickButton}
          rate={rate}
          startDate={startDate}
          unit={unit}
        />
      }
      isModalOnly
      onClick={onClick}
    >
      {children}
    </PopOver>
  );
};
